import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const enquiryApi = createApi({
  reducerPath: "enquiryApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL,
    // ⚠️ No credentials needed (public API)
  }),
  endpoints: (builder) => ({

    /* -------------------- SUBMIT ENQUIRY -------------------- */
    submitEnquiry: builder.mutation({
      query: (body) => ({
        url: "/end-user/enquiry",
        method: "POST",
        body,
      }),
    }),

  }),
});

export const {
  useSubmitEnquiryMutation,
} = enquiryApi;

export default enquiryApi;